import moment, { unitOfTime } from 'moment'
import { EntityStatusState } from '@/store/root/root-store.model'
import { SimpleListResponse } from '@/api/services/common/simple-list/common-simple-list.dto'

export class VtGridComparator {
    private static _innerDateComparator(filterDate: Date, cellValue: Date, granularity?: unitOfTime.StartOf): number {
        if (moment(cellValue).isBefore(filterDate, granularity)) {
            return -1
        } else if (moment(cellValue).isAfter(filterDate, granularity)) {
            return 1
        }
        return 0
    }
    static dateComparator(filterDate: Date, cellValue: Date): number {
        return VtGridComparator._innerDateComparator(filterDate, cellValue, 'day')
    }
    static dateTimeComparator(filterDate: Date, cellValue: Date): number {
        return VtGridComparator._innerDateComparator(filterDate, cellValue, 'minute')
    }

    static entityStatusStateComparator(codeA: string, codeB: string, states: EntityStatusState[]): number {
        const a = states.find(state => state.code === codeA)
        const b = states.find(state => state.code === codeB)

        const orderA = a?.order ?? 0
        const orderB = b?.order ?? 0
        if (orderA === orderB) {
            return 0
        }
        return orderA > orderB ? 1 : -1
    }

    static entitySimpleListComparator(idA: string, idB: string, list: SimpleListResponse[]): number {
        const a = list.find(item => item.id === idA)
        const b = list.find(item => item.id === idB)

        const labelA = a?.label ?? ''
        const labelB = b?.label ?? ''
        return labelA.localeCompare(labelB)
    }
}
